import { notification } from "antd";
import { BillingCode, describeBillingError } from "./billingCodes";

// Adding a workspace (POST Workspaces/add) or a project (POST Projects/add), and
// bringing one back from Deleted items (toggleDeleteOrRestore) or from the
// archive (toggleArchive), is refused when the plan has no room for it — or a
// smaller plan already scheduled has none: 409 PLAN_LIMIT_EXCEEDED, with a
// message for the user that names the plan and what it holds. Decided by the
// code, never by the text.

// The answer a failure carries: an axios rejection's body, or a failed envelope
// itself (httpService hands a 2xx with isSuccess false to its error callback).
const answerOf = (failure) =>
   failure?.response?.data ?? (typeof failure?.statusCode === "number" ? failure : null);

/** Whether a failed add or restore was refused for the plan's limits. */
export const isPlanLimitRefusal = (failure) =>
   answerOf(failure)?.code === BillingCode.PLAN_LIMIT_EXCEEDED;

/**
 * Says why, in the server's words, when the failure is that refusal, and returns
 * true. Anything else is left to the caller: false.
 */
export const notifyPlanLimitRefusal = (failure) => {
   if (!isPlanLimitRefusal(failure)) return false;

   notification.error({
      message: "Oops! A problem has occurred!",
      description: describeBillingError({
         code: BillingCode.PLAN_LIMIT_EXCEEDED,
         serverMessage: answerOf(failure).message
      })
   });
   return true;
};
